/**
 * 获取url后参数
 */
export const GetRequest = () => {
    let url = location.search; //获取url中"?"符后的字串
    let theRequest = new Object();
    if (url.indexOf("?") != -1) {
        let str = url.substr(1);
        let strs = str.split("&");
        for (let i = 0; i < strs.length; i++) {
            theRequest[strs[i].split("=")[0]] = strs[i].split("=")[1];
        }
    }
    return theRequest;
};

//防抖
export function debounce(fn, wait) {
    let timeout = null;
    wait = wait || 600;
    return function () {
      let that = this;
      if(timeout !== null)   clearTimeout(timeout);  
      timeout = setTimeout(() => {
        fn.apply(that);
      }, wait);
    }    
}

//二分法查询区间所在对象
export function findRangeByValue(ranges, value) {
    let left = 0;
    let right = ranges.length - 1;
    
    while (left <= right) {
        const mid = Math.floor((left + right) / 2);
        const range = ranges[mid];
        
        if (value >= range.range[0] && value < range.range[1]) {
            return range;
        } else if (value < range.range[0]) {
            right = mid - 1;
        } else {
            left = mid + 1;
        }
    }
    return null; // 没找到对应区间
}

export function allSettled (promises) {
    return new Promise((resolve, reject) => {
        const results = [];
        let settledCount = 0;
        const total = promises.length;

        promises.forEach((promise, index) => {
            promise.then(
                value => { results[index] = { status: 'fulfilled', value }; checkDone(); },
                reason => { results[index] = { status: 'rejected', reason }; checkDone(); }
            );
        });

        function checkDone() {
            settledCount++;
            if (settledCount === total) {
                resolve(results);
            }
        }
    });
}

//删除url指定参数
export function removeURLParameter(url, parameter) {
    var urlParts = url.split('?');
    if (urlParts.length >= 2) {
        var prefix = encodeURIComponent(parameter) + '=';
        var pars = urlParts[1].split(/[&;]/g);
        for (var i = pars.length; i-- > 0;) {
            if (pars[i].lastIndexOf(prefix, 0) !== -1) {
                pars.splice(i, 1);
            }
        }
        return urlParts[0] + '?' + pars.join('&');
    } else {
        return url;
    }
}


// 文本路径转化为链接
export function urlify(text,className,target = '_blank') {
  // 正则表达式匹配URL，包括带括号的和不带的
    const urlPattern = /(\bhttps?:\/\/[\-A-Z0-9+&@#\/%?=~_|!:,.;]*[\-A-Z0-9+&@#\/%=~_|])/ig;
    const urlWithBracketsPattern = /(\(|\[|\{)https?:\/\/[^\s()<>]+(?:\([\w\d]+\)|([^[:punct:]\s]|\/))(\)|\]|\})/gi;

    const result = text.replace(urlPattern, (match) => {
        // 检查是否为带括号的URL
        if (urlWithBracketsPattern.test(match)) {
            // 去除括号
            const url = match.slice(1, -1);
            return `<a href="${url}" target="${target}" class="${className}">${url}</a>`;
        } else {
            return `<a href="${match}" target="${target}" class="${className}">${match}</a>`;
        }
    });

    return result;
}